import { ViewAll } from '../common/viewAll';
import AmcsList from '../common/amcsList';

export const FundHousesSection = ({ otherAMCList }) => (
  <div id="fund-houses" className="lil-container lil-mt-16 sm:lil-mt-12">
    <div className=" lil-pt-6 lil-items-center sm:lil-items-start">
      <h2 className="lil-py-2 lil-text-s-56 sm:lil-text-s-32">
        Explore fund houses
      </h2>
      <AmcsList amcList={otherAMCList} parts={4} />
      <ViewAll
        title="View all fund houses"
        link="/mutual-funds/catalogue"
        classes="lil-mt-5"
      />
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./components/homePageNew/fundHouses.tsx